import React, { useEffect, useState } from 'react'
import styles from '../styles/ShowEmailContent.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from '../../Common';
import { Empty, message } from 'antd';
import ReactHtmlParser from "react-html-parser";
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import CommonNavbar from './CommonNavbar';
import { decryptQuery } from '../../Common/utils/universalFuntions';
import { closingActions } from '../../TransactionReport/state/actions';
import { useMediaQuery } from 'react-responsive';
import axios from 'axios';

function ShowEmailLogs() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabId = queryParams.get('tabId');
    const encryptedCurrentObject = queryParams.get('data');
    const decryptedCurrentObject = decryptQuery(decodeURIComponent(encryptedCurrentObject));
    let { from, source, contractAuthKey, rootDocData, logId } = decryptedCurrentObject;
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);
    const { getEmailLogsLoading, getEmailLogsData, getEmailLogsError } = useSelector((state) => state.transactionReport);
    const isMobile = useMediaQuery({maxWidth: 500});

    useEffect(() => {
        let unmounted = {
            value: false
        };
        let sourceAxios = axios.CancelToken.source();
        if (logId) {
            dispatch(closingActions.getEmailLogs({ accessToken: contractAuthKey, queryData: { logId }, sourceAxios, unmounted }));
        } else {
            let viewFrom = ["SELLER", "SELLER_AGENT"].includes(rootDocData?.openFor) ? "SELLING" : ["BUYER", "BUYER_AGENT"].includes(rootDocData?.openFor) ? "BUYING" : null;
            let openFor = ["SELLER", "SELLER_AGENT"].includes(rootDocData?.openFor) ? "SELLER_AGENT" : ["BUYER", "BUYER_AGENT"].includes(rootDocData?.openFor) ? "BUYER_AGENT" : null;
            dispatch(closingActions.getEmailLogs({ accessToken: contractAuthKey, queryData: { offerId: rootDocData.offerId, propertyId: rootDocData.propertyId, sourceAxios, unmounted, viewFrom, openFor } }));
        }
        return () => {
            unmounted.value = true;
            sourceAxios.cancel("Operation canceled by the user.");
        }
    }, []);

    useEffect(() => {
        if (from) {
            setFilteredData(getEmailLogsData?.filter((data) => data?.from === from));
        } else {
            setFilteredData(getEmailLogsData);
        }
    }, [from, getEmailLogsData]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const cleanHtml = (html) => {
        if (!html) return '';
    
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
    
        const allElements = tempDiv.querySelectorAll('*');
    
        allElements.forEach(element => {
            const style = element.getAttribute('style');
            if (style) {
                const tag = element.tagName.toLowerCase();
    
                const newStyle = style
                    .split(';')
                    .map(rule => rule.trim())
                    .filter(rule => {
                        // Keep all styles for <img>
                        if (tag === 'img') return true;
    
                        // Remove font-size for other tags
                        if (rule.startsWith('font-size')) return false;
    
                        // Remove width in px for other tags
                        if (rule.startsWith('width') && rule.includes('px')) return false;
    
                        return true;
                    });
    
                // If it's a button, force width: 100%
                if (tag === 'button') {
                    newStyle.push('width: 100%');
                }
    
                if (newStyle.length) {
                    element.setAttribute('style', newStyle.join('; '));
                } else {
                    element.removeAttribute('style');
                }
            }
        });
    
        return tempDiv.innerHTML;
    };

    return (
        <div className={styles.EmailPageOuterContainer}>
            <CommonNavbar source={"ShowEmailLogs"} tabId={tabId ? `${tabId}_page2` : null} />
            <div className={styles.emailScreenContainer}>
                {
                    getEmailLogsLoading ? <Loading /> :
                        getEmailLogsError ? message.error("Couldn't retrieve the email.") :
                            filteredData?.length ?
                                filteredData?.map((setEmailData, index) => {
                                    return <div>
                                        {/* <div className={`${styles.outerBox} ${styles.outerBoxEmailLogs}`} key={index} style={{ width: isMobile ? '100%' : '80%' }}> */}
                                        <div className={`${styles.outerBox} ${styles.outerBoxEmailLogs}`} key={index}>
                                            {/* return <div  key={index}> */}
                                            <div className={styles.subject}><span style={{ color: 'black' }}>Subject:&emsp;</span>{setEmailData?.subject}</div>
                                            {/* <div className={styles.date}>{setEmailData?.date ? moment(setEmailData.date).format('MM-DD-YYYY') : ''}</div> */}

                                            {/* <div className={styles.date}>
                                            {setEmailData?.date ? moment(setEmailData.date).format('MM-DD-YYYY hh:mm A') : ''}
                                            </div> */}

                                            <div className={styles.date}>
                                                {setEmailData?.sentDate ? moment(setEmailData.sentDate).format('ddd, MMM D, h:mm A') + ' (' + moment(setEmailData.sentDate).fromNow() + ')' : ''}
                                            </div>

                                            <div className={styles.emailDetails}>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className={styles.label}>From:</td>
                                                            <td className={styles.value}>
                                                                {setEmailData?.delegateId?.fullName && setEmailData?.delegateId?.email ? (
                                                                    <>
                                                                    <div>Mail Sent by Delegate <span style={{ fontWeight: 'bold', color: 'orange' }}>{setEmailData?.delegateId?.fullName}</span> &lt;<a href={`mailto:${setEmailData?.delegateId?.email}`}>{setEmailData?.delegateId?.email}</a>&gt;</div>
                                                                        on behalf of&nbsp;
                                                                        {
                                                                            setEmailData?.personId?.fullName && setEmailData?.personId?.email ? (
                                                                                <>
                                                                                    <span style={{ fontWeight: 'bold', color: 'orange' }}>{setEmailData?.personId?.fullName}</span> &lt;<a href={`mailto:${setEmailData?.personId?.email}`}>{setEmailData?.personId?.email}</a>&gt;
                                                                                </>
                                                                            ) : "Main Realtor"
                                                                        }
                                                                    </>) :
                                                                    setEmailData?.personId?.fullName && setEmailData?.personId?.email ? (
                                                                        <>
                                                                            <span style={{ fontWeight: 'bold', color: 'orange' }}>{setEmailData?.personId?.fullName}</span> &lt;<a href={`mailto:${setEmailData?.personId?.email}`}>{setEmailData?.personId?.email}</a>&gt;
                                                                        </>
                                                                    ) : (
                                                                        <div><span>{""}</span>&lt;<a href={`mailto:${setEmailData?.from}`}>{setEmailData?.from}</a>&gt;</div>
                                                                    )}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className={styles.label}>To:</td>
                                                            <td className={styles.value}>
                                                                {setEmailData?.receiverPersonId?.fullName && setEmailData?.receiverPersonId?.email ? (
                                                                    <>
                                                                        <span style={{ fontWeight: 'bold', color: 'orange' }}>{setEmailData?.receiverPersonId?.fullName}</span> &lt;<a href={`mailto:${setEmailData?.receiverPersonId?.email}`}>{setEmailData?.receiverPersonId?.email}</a>&gt;
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {setEmailData?.receiverPersonFullName ? <span style={{ fontWeight: 'bold', color: 'orange' }}>{setEmailData?.receiverPersonFullName}</span> : ''}
                                                                        <span>&nbsp;&lt;<a href={`mailto:${setEmailData.originalTo}`}>{setEmailData.originalTo}</a>&gt;</span>
                                                                    </>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        {setEmailData?.originalCc?.length ? <tr>
                                                            <td className={styles.label}>CC:</td>
                                                            <td className={styles.value}>
                                                                {setEmailData.originalCc?.map((cc, index) => (
                                                                    <div key={index}>&lt;<a href={`mailto:${cc}`}>{cc}</a>&gt;</div>
                                                                ))}
                                                            </td>
                                                        </tr> : null}
                                                        {/* {forwardedTo?.length ? <tr>
                                                        <td className={styles.label}>Forwarded To:</td>
                                                        <td className={styles.value}>
                                                            {forwardedTo?.map((fwdTo, index) => (
                                                                <div key={index}>&lt;<a href={`mailto:${fwdTo}`}>{fwdTo}</a>&gt;</div>
                                                            ))}
                                                        </td>
                                                    </tr> : null} */}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className={styles.emailBody}>
                                                {ReactHtmlParser(cleanHtml(setEmailData?.body?.emailBody))}
                                            </div>

                                            {/* <div className={styles.emailAttachments}>
                                            {setEmailData?.attachments?.length ? "Here you can download the attached pdf files:" : ""}
                                            {setEmailData?.attachments?.map((attachment, index) => (
                                                <div key={index}>
                                                    {attachment?.contentType === "application/pdf" && attachment?.content?.type === 'Buffer' ? (
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                const blob = new Blob([Buffer.from(attachment.content?.data)], { type: attachment.contentType });
                                                                const url = window.URL.createObjectURL(blob);
                                                                const a = document.createElement('a');
                                                                a.href = url;
                                                                a.download = attachment.filename;
                                                                document.body.appendChild(a);
                                                                a.click();
                                                                document.body.removeChild(a);
                                                                window.URL.revokeObjectURL(url);
                                                            }}
                                                        >
                                                            Download : {attachment.filename}
                                                        </a>
                                                    ) : null}
                                                </div>
                                            ))}
                                        </div> */}
                                        </div>
                                        {filteredData?.length > 1 &&
                                            <div style={{ padding: 10, }}>
                                                <hr style={{ height: '5px', backgroundColor: '#124e8f' }} />
                                            </div>
                                        }
                                    </div>
                                }
                            )
                        :
                    <div style={{backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh'}}>
                        <Empty />
                    </div> 
                }
            </div>
        </div>
    )
}

export default ShowEmailLogs